import { render } from "./clientManagement.vue?vue&type=template&id=4eb5abb1"
import script from "./clientManagement.vue?vue&type=script&lang=js"
export * from "./clientManagement.vue?vue&type=script&lang=js"

import "./clientManagement.vue?vue&type=style&index=0&id=4eb5abb1&lang=scss"
script.render = render

export default script